__turbopack_context__.v({
  "blocksBackgroundColor": "PageSearchResult-module-scss-module__aXRo2W__blocksBackgroundColor",
  "blocksFontColor": "PageSearchResult-module-scss-module__aXRo2W__blocksFontColor",
  "breadcrumbs": "PageSearchResult-module-scss-module__aXRo2W__breadcrumbs",
  "content": "PageSearchResult-module-scss-module__aXRo2W__content",
  "result": "PageSearchResult-module-scss-module__aXRo2W__result",
  "secondaryNavBackgroundColor": "PageSearchResult-module-scss-module__aXRo2W__secondaryNavBackgroundColor",
  "themeBackgroundColor": "PageSearchResult-module-scss-module__aXRo2W__themeBackgroundColor",
  "themeFontColor": "PageSearchResult-module-scss-module__aXRo2W__themeFontColor",
  "themeFontFamily": "PageSearchResult-module-scss-module__aXRo2W__themeFontFamily",
});
